import "@styles/components/Footer.scss";

export default function Footer() {
    return (
        <footer className="footer">
            <div className="container footer-content">
                <div className="footer-section">
                    <h3>166studios</h3>
                    <p>
                        side by side with technology and art
                    </p>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <p>© 166studios 2025. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}
